import { Component } from '@angular/core';

import { MessengerSmsComponent } from '../messages/messenger/messenger.sms.component';

@Component({
  selector   : 'inspection-sms',
  template: require('./inspection.sms.component.html')
})
export class InspectionSmsComponent extends MessengerSmsComponent {}
